// Themes
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

export const PAYMENT_TERMS = {
  PIA: "PIA", // pay in advance
  COD: "COD", // cash on delivery
  NET7: "Net7",
  NET30: "Net30",
  NET60: "Net60",
};
